import { useState } from 'react';

export default function useCustomAlert() {
  const [alertState, setAlertState] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info',
    showConfirm: false,
    onConfirm: null,
    confirmText: 'Confirmar',
    cancelText: 'Cancelar'
  });

  const closeAlert = () => {
    setAlertState(prev => ({
      ...prev,
      isOpen: false
    }));
  };

  const showAlert = (config) => {
    setAlertState({
      isOpen: true,
      title: config.title || '',
      message: config.message || '',
      type: config.type || 'info',
      showConfirm: config.showConfirm || false,
      onConfirm: config.onConfirm || null,
      confirmText: config.confirmText || 'Confirmar',
      cancelText: config.cancelText || 'Cancelar'
    });
  };

  const showSuccess = (message, title = '') => {
    showAlert({
      type: 'success',
      title,
      message
    });
  };

  const showError = (message, title = '') => {
    showAlert({
      type: 'error',
      title,
      message
    });
  };

  const showWarning = (message, title = '') => {
    showAlert({
      type: 'warning',
      title,
      message
    });
  };

  const showInfo = (message, title = '') => {
    showAlert({
      type: 'info',
      title,
      message
    });
  };

  const showConfirm = (config) => {
    showAlert({
      type: config.type || 'warning',
      title: config.title || '',
      message: config.message || '',
      showConfirm: true,
      onConfirm: config.onConfirm,
      confirmText: config.confirmText || 'Confirmar',
      cancelText: config.cancelText || 'Cancelar'
    });
  };

  return {
    alertProps: {
      ...alertState,
      onClose: closeAlert
    },
    showAlert,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showConfirm,
    closeAlert
  };
}